import { render, staticRenderFns } from "./PhoneExtension.vue?vue&type=template&id=2fa33d32"
import script from "./PhoneExtension.vue?vue&type=script&lang=js"
export * from "./PhoneExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports